import Index from './index.vue'
import WalletBalances from './views/WalletBalances.vue'
import CreditsUsedByMonth from './views/CreditsUsedByMonth.vue'
import CreditsPurchasedVsUsed from './views/CreditsPurchasedVsUsed.vue'
import RefundHistory from './views/RefundHistory.vue'

export default [
  {
    path: 'sms-reports',
    name: 'sms-reports',
    component: Index,
    title: 'SMS Reports',
    redirect: { name: 'sms-reports-wallet-balances' },
    children: [
      {
        path: 'wallet-balances',
        name: 'sms-reports-wallet-balances',
        component: WalletBalances,
      },
      {
        path: 'usage-by-month',
        name: 'sms-reports-usage-by-month',
        component: CreditsUsedByMonth,
      },
      {
        path: 'purchased-vs-used',
        name: 'sms-reports-purchased-vs-used',
        component: CreditsPurchasedVsUsed,
      },
      {
        path: 'refund-history',
        name: 'sms-reports-refund-history',
        component: RefundHistory,
      },
    ],
  },
]
